module.exports = __webpack_public_path__ + "static/media/instagram.47c62588.svg";